module.exports = __webpack_public_path__ + "static/lemon-d6c22752bd9f0cba72b885c893d5668e.svg";